function truncateWithEllipsis(
  activitate: boolean,
  str: string,
  limit: number
): string {
  if (!activitate || str.length <= limit) {
    return str;
  }
  return str.slice(0, limit) + '...';
}

export function getUniqueId(): string {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36);
  return dateString + randomness;
}
export function generateRandomNumber() {
  const now = Date.now();
  const random = Math.floor(Math.random() * 10000);
  const randomNumber = (now + random).toString().slice(-8);
  return randomNumber;
}
export function groupAndSortArray(
  arr: any[],
  property: string,
  sortFn: (
    a: { [key: string]: any },
    b: { [key: string]: any }
  ) => number = () => 0
) {
  return (
    Object.values(
      arr.reduce((acc: { [key: string]: any[] }, item) => {
        const key = item[property]; // Replace 'property' with your actual grouping property
        (acc[key] || (acc[key] = [])).push(item);
        return acc;
      }, {})
    )

      // Assuming objects within the array
      .flatMap((group: any[]) => group.sort(sortFn))
  ); // Replace 'name' with your sorting property
}
export { truncateWithEllipsis };

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
